module.exports = __webpack_public_path__ + "static/media/MongoDB-Logo.6aac6ad7.svg";